import { type IconProps, Icon as VolvoIcon } from '@volvo-cars/react-icons';
import { forwardRef } from 'react';

type Props = Omit<IconProps, 'size'> & {
  size?: IconProps['size'];
};

const Icon = forwardRef<HTMLImageElement, Props>(
  ({ size = 16, color = 'inherit', ...restProps }, ref) => (
    <VolvoIcon ref={ref} size={size} color={color} {...restProps} />
  ),
);

Icon.displayName = 'Icon';

export default Icon;
